// extracted by mini-css-extract-plugin
export default {"column":"FilterWell__column--VtEk7a","columnHeader":"FilterWell__columnHeader--eFryIx"};